import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import { Home, ArrowRight } from "lucide-react";

const LINKS = [
  ["/conciergerie-airbnb-rouen", "Conciergerie Airbnb à Rouen"],
  ["/tarifs-conciergerie-rouen", "Nos tarifs"],
  ["/estimation-revenus-airbnb-rouen", "Estimer mes revenus"],
  ["/reglementation-airbnb-rouen", "Réglementation Airbnb Rouen"],
  ["/logements", "Nos logements"],
  ["/contact", "Contact"],
];

export default function NotFound() {
  return (
    <Layout>
      <Seo
        title="Page introuvable (404) | NJ Conciergerie Rouen"
        description="La page demandée est introuvable. Retrouvez la conciergerie Airbnb NJ Conciergerie à Rouen : tarifs, estimation et nos logements."
        noindex
      />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 text-center" data-testid="notfound-page">
        <span className="text-nj-gold text-xs tracking-[0.28em] uppercase font-semibold">Erreur 404</span>
        <h1 className="font-serif font-light text-4xl sm:text-5xl text-nj-primary mt-3">Cette page est introuvable</h1>
        <p className="text-nj-text2 text-lg mt-4">La page que vous cherchez n'existe pas ou a été déplacée. Revenez à l'accueil ou explorez nos pages principales.</p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-2 bg-nj-primary hover:bg-nj-primaryHover text-white font-semibold px-6 py-3 rounded-sm transition-colors">
            <Home className="w-4 h-4" /> Retour à l'accueil
          </Link>
          <Link to="/estimation-revenus-airbnb-rouen" className="inline-flex items-center gap-2 border border-nj-primary text-nj-primary font-semibold px-6 py-3 rounded-sm hover:bg-nj-olive/40 transition-colors">
            Estimer mes revenus <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <nav aria-label="Pages utiles" className="mt-10 flex flex-wrap gap-x-6 gap-y-2 justify-center text-sm">
          {LINKS.map(([to, label]) => (
            <Link key={to} to={to} className="text-nj-primary hover:underline">{label}</Link>
          ))}
        </nav>
        <p className="text-sm text-nj-muted mt-10">Une question ? <a href="tel:+33666934267" className="text-nj-primary font-semibold">06 66 93 42 67</a> · 22 boulevard de la Marne, 76000 Rouen</p>
      </section>
    </Layout>
  );
}
